export default function MeetTheTeam() {
  const teamMembers = [
    {
      name: "Max Mitchell",
      role: "Founder",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/112225f53adc0751403eeead78c4577a89cc7b94?width=634",
    },
    {
      name: "Sarah Johnson",
      role: "Chief Real Estate Officer",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/7a92d3c7bc9bf504a2e4079e99a37208eeacdc5d?width=634",
    },
    {
      name: "David Brown",
      role: "Head of Property Management",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/b4e65bc820d7d731269b0224bd7b9b815ae63a55?width=634",
    },
    {
      name: "Michael Turner",
      role: "Legal Counsel",
      image: "https://api.builder.io/api/v1/image/assets/TEMP/4e00722b125b5dbfdc2ba8da5577740b82df7554?width=634",
    },
  ];

  return (
    <div className="w-full bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="mx-auto max-w-6xl">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16 max-w-4xl">
          <div className="relative mb-2">
       
            
            <h1 className="text-primary text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] font-urbanist">
              Meet the Alkina Realty Team
            </h1>
          </div>
          <p className="text-[#666666] text-sm md:text-base leading-[150%] font-medium font-urbanist">
            At Alkina Realty, our success is driven by the dedication and expertise of our team. Get to know the people behind our mission to make your real estate dreams a reality.
          </p>
        </div>

        {/* Team Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="flex flex-col gap-4 p-4 md:p-5 lg:p-6 border border-gray-200 bg-white shadow-lg"
            >
              {/* Image Container with Twitter Button */}
              <div className="relative">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-[140px] md:h-[160px] object-contain md:object-cover"
                />
                {/* Twitter Button Overlay */}
                <button 
                  className="absolute bottom-[-12px] left-1/2 -translate-x-1/2 flex items-center justify-center p-2 px-4-[43px] bg-[#917c66] hover:bg-[#7a6754] transition-colors"
                  aria-label="Twitter"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.55016 21.75C16.6045 21.75 21.5583 14.2467 21.5583 7.74186C21.5583 7.53092 21.5536 7.3153 21.5442 7.10436C22.5079 6.40746 23.3395 5.54425 24 4.5553C23.1025 4.9546 22.1496 5.21538 21.1739 5.32874C22.2013 4.71291 22.9705 3.74547 23.3391 2.60577C22.3726 3.17856 21.3156 3.58261 20.2134 3.80061C19.4708 3.01156 18.489 2.48912 17.4197 2.31405C16.3504 2.13899 15.2532 2.32105 14.2977 2.8321C13.3423 3.34314 12.5818 4.15471 12.1338 5.14131C11.6859 6.12792 11.5754 7.23462 11.8195 8.2903C9.86249 8.19209 7.94794 7.6837 6.19998 6.7981C4.45203 5.91249 2.90969 4.66944 1.67297 3.14952C1.0444 4.23324 0.852057 5.51565 1.13503 6.73609C1.418 7.95654 2.15506 9.02345 3.19641 9.71999C2.41463 9.69517 1.64998 9.48468 0.965625 9.10592V9.16686C0.964925 10.3041 1.3581 11.4066 2.07831 12.2868C2.79852 13.167 3.80132 13.7706 4.91625 13.995C4.19206 14.1931 3.43198 14.222 2.69484 14.0794C3.00945 15.0574 3.62157 15.9129 4.44577 16.5263C5.26997 17.1398 6.26512 17.4806 7.29234 17.5012C5.54842 18.8711 3.39417 19.6141 1.17656 19.6106C0.783287 19.61 0.390399 19.5859 0 19.5384C2.25286 20.9837 4.87353 21.7514 7.55016 21.75Z" fill="currentColor" className="text-[var(--color-secondary)]"/>
                  </svg>
                </button>
              </div>

              {/* Content Container */}
              <div className="flex flex-col gap-3">
                {/* Name and Role */}
                <div className="flex flex-col items-center gap-0.5">
                  <h3 className="text-black text-base md:text-lg font-semibold leading-6 text-center font-urbanist">
                    {member.name}
                  </h3>
                  <p className="text-[#666666] text-sm md:text-base font-medium leading-5 text-center font-urbanist">
                    {member.role}
                  </p>
                </div>

                {/* Say Hello Button */}
                <button className="flex items-center gap-3 py-2 pl-4 pr-2 border border-gray-200 bg-white hover:bg-gray-50 transition-colors group">
                  <span className="flex-1 text-black text-sm font-medium leading-6 text-left font-urbanist">
                    Say Hello 👋
                  </span>
                  <div className="flex items-center justify-center p-1.5 bg-[#917c66] group-hover:bg-[#7a6754] transition-colors">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.4274 2.5783C20.9274 2.0673 20.1874 1.8783 19.4974 2.0783L3.40742 6.7273C2.67942 6.9293 2.16342 7.5063 2.02442 8.2383C1.88242 8.9843 2.37842 9.9323 3.02642 10.3283L8.05742 13.4003C8.57342 13.7163 9.23942 13.6373 9.66642 13.2093L15.4274 7.4483C15.7174 7.1473 16.1974 7.1473 16.4874 7.4483C16.7774 7.7373 16.7774 8.2083 16.4874 8.5083L10.7164 14.2693C10.2884 14.6973 10.2084 15.3613 10.5234 15.8783L13.5974 20.9283C13.9574 21.5273 14.5774 21.8683 15.2574 21.8683C15.3374 21.8683 15.4274 21.8683 15.5074 21.8573C16.2874 21.7583 16.9074 21.2273 17.1374 20.4773L21.9074 4.5083C22.1174 3.8283 21.9274 3.0883 21.4274 2.5783Z" fill="currentColor" className="text-[var(--color-secondary)]"/>
                      <path opacity="0.4" d="M9.45139 19.1423C9.74339 19.4353 9.74339 19.9103 9.45139 20.2033L8.08539 21.5683C7.93939 21.7153 7.74739 21.7883 7.55539 21.7883C7.36339 21.7883 7.17139 21.7153 7.02539 21.5683C6.73239 21.2753 6.73239 20.8013 7.02539 20.5083L8.39039 19.1423C8.68339 18.8503 9.15839 18.8503 9.45139 19.1423ZM8.66769 15.3543C8.95969 15.6473 8.95969 16.1223 8.66769 16.4153L7.30169 17.7803C7.15569 17.9273 6.96369 18.0003 6.77169 18.0003C6.57969 18.0003 6.38769 17.9273 6.24169 17.7803C5.94869 17.4873 5.94869 17.0133 6.24169 16.7203L7.60669 15.3543C7.89969 15.0623 8.37469 15.0623 8.66769 15.3543ZM4.90649 14.1619C5.19849 14.4549 5.19849 14.9299 4.90649 15.2229L3.54049 16.5879C3.39449 16.7349 3.20249 16.8079 3.01049 16.8079C2.81849 16.8079 2.62649 16.7349 2.48049 16.5879C2.18749 16.2949 2.18749 15.8209 2.48049 15.5279L3.84549 14.1619C4.13849 13.8699 4.61349 13.8699 4.90649 14.1619Z" fill="currentColor" className="text-[var(--color-secondary)]"/>
                    </svg>
                  </div>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


